import { DateTime } from 'luxon';
import { TimeSignal } from 'graphql/types';
import { UpdateTimeSignalInput } from 'graphql/types';
import { validateDuration } from 'modules/notes/common';
import { SignalMetaType, NotesBackgroundStorageParams } from './types';

export const extractSignalMetaData = (note: TimeSignal): SignalMetaType => ({
  duration: note?.duration ?? 0,
  id: note.id,
  description: note?.description || null,
  startTime: note?.startTime || null,
  date: note.date || null,
  endTime: note?.endTime || null
});

export const mapBackgroundNoteToTimeSignal = (
  backgroundSignal: NotesBackgroundStorageParams,
  calculatedDuration: number
): UpdateTimeSignalInput => {
  const timeSignal = {
    id: backgroundSignal?.id,
    duration: calculatedDuration
  } as UpdateTimeSignalInput;

  if (backgroundSignal?.meta?.startTime && backgroundSignal?.meta?.endTime) {
    const start = DateTime.fromISO(backgroundSignal?.meta?.startTime);
    const end = DateTime.fromISO(backgroundSignal?.meta?.endTime);
    const isDurationExceeding = validateDuration(
      start,
      end,
      calculatedDuration
    );
    const currentTime = DateTime.local();
    const signalDate = DateTime.fromISO(backgroundSignal?.meta?.date).endOf(
      'day'
    );
    if (signalDate < currentTime) {
      timeSignal.endTime = signalDate.toUTC();
    } else if (isDurationExceeding) {
      timeSignal.endTime = currentTime.toUTC();
    }
  }
  return timeSignal;
};
